import { isAfter, lastDayOfMonth, startOfMonth } from 'date-fns';

/** The month a month filter shows: the month its period starts in, else today's. */
export function monthOfPeriod(from: string | null | undefined, today: Date): Date {
    return startOfMonth(from ? new Date(from) : today);
}

/** A month filter offers no month after today's. */
export function isPickableMonth(month: Date, today: Date): boolean {
    return !isAfter(startOfMonth(month), startOfMonth(today));
}

/** The period a month sets: its first and its last day, at local midnight. */
export function monthRange(month: Date): { from: Date; to: Date } {
    return { from: startOfMonth(month), to: lastDayOfMonth(month) };
}
